app.components.fancybox = {
    onReady: () => {
        if ($('[data-fancybox]').length || $('[data-fancybox-gallery]').length) {
            return true;
        }
    },
    addListener: async () => {

        try {
            const Fancyapps = await import('@fancyapps/ui')
            await import('@fancyapps/ui/dist/fancybox/fancybox.css')

            Fancyapps.Fancybox.bind('[data-fancybox="image"]', {
                fitToView: true,
                Images: {
                    zoom: false,
                },
                closeButton: true,
                on: {
                    done: (fancybox, slide) => {
                        try {
                            wpforms.ready();
                        } catch (e) {
                        }
                    },
                },
            })

            Fancyapps.Fancybox.bind('[data-fancybox="gallery"]', {
                infinite: true,
                animated: true,
                mainClass: "video-player-styles",
                video: {
                    autoplay: false,
                },
                dragToClose: true,
                keyboard: {
                    Escape: "close",
                    ArrowLeft: "prev",
                    ArrowRight: "next",
                },
                Toolbar: {
                    display: [
                        "close",
                        "prev",
                        "next",
                    ]
                },
                Thumbs: false, // disable thumbnail bar
            })

            $('[data-fancybox-gallery]').on('click', function () {
                const data = $(this).data('gallery-json');
                new Fancyapps.Fancybox(
                    data,
                    {
                        Toolbar: {
                            display: {
                                left: [],
                                middle: ["prev", "infobar", "next"],
                                right: ["close"],
                            },
                        },
                        Fullscreen: {
                            autoStart: false,
                        },
                        fitToView: true,
                        height: function () {
                            return screen.height * 0.8;
                        },
                        Images: {
                            zoom: false,
                            protected: true,
                        }
                    }
                )
            })

        } catch (error) {
            console.error('Error loading modules:', error)
        }
    }
};
